@if (showheaderoncomplete != 'complete') {
  <div class="home-header fx-row" [ngClass]="{'midHeader': (isTop && (currentRouterPath == '/home')) , 'midHeader1' : !isTop }">
    @if (currentRouterPath == '/home') {
      <mat-toolbar class="fx-flex-100 lt-md-fx-hide" color="primary"
        [ngClass]="{'noColor header p-0-10': isTop , 'kuro header' : !isTop }">
        <mat-toolbar-row class="container p-0 h-90 fx-row">
          <div class="mt p-l-20 p-r-20 fx-row">
            <div>
              <p class="margin-img">
                <a class="c-white logo" routerLink="/home"><img src="../../../../assets/images/logo_small.png"
                  class="width-img" />
              </a>
            </p>
          </div>
          <div class="m-l-30 fx-row fx-main-center fx-cross-center">
            <p class="heading">
              <span class="m-l-10 f-w-100" [ngClass]="{'text-gray': '/home' ? router.isActive('/home', true): false}"
              routerLink="/home">Home</span>
              <span class="m-l-15 f-w-100"
                [ngClass]="{'text-gray': '/products/all' ? router.isActive('/products/all', true): false}"
              routerLink="/products/all">Shop</span>
              <span class="m-l-15 f-w-100" [ngClass]="{'text-gray': '/faq' ? router.isActive('/faq', true): false}"
              routerLink="/faq">FAQ</span>
              @if (!isLoggedIn()) {
                <span class="m-l-15 f-w-100"
                  [ngClass]="{'text-gray': '/join' ? router.isActive('/join', true): false}"
                routerLink="/join">Join</span>
              }
              <span class="m-l-15 f-w-100"
                [ngClass]="{'text-gray': '/contact' ? router.isActive('/contact', true): false}"
              routerLink="/contact">Contact</span>
              <span class="m-l-15 f-w-100" [ngClass]="{'text-gray': '/about' ? router.isActive('/about', true): false}"
              routerLink="/about">About</span>
            </p>
          </div>
          <mat-menu class="fx-row-in-menu" #menu="matMenu">
            <div id="header-menu" class="p-20 line_space fx-row fx-flex-100 fx-gap-right-20px">
              <div class="fx-row fx-flex-100">
                <div class="fx-row-wrap fx-main-start fx-cross-stretch fx-flex-100">
                  @for (category of allItems; track category; let i = $index) {
                    <div class="fx-col fx-main-start fx-cross-start fx-fill-size fx-flex-25-in-wrap lt-md-fx-flex-48-in-wrap"
                      >
                      <div
                        class="p-relative fx-col fx-main-start fx-cross-start fx-fill-size fx-flex-24-in-col lt-md-fx-flex-100-in-col">
                        <b><span [routerLink]="['/products', category.CategoryId]">{{category.Category}}</span></b>
                        <span [routerLink]="['/products',category.CategoryId]">All</span>
                        @for (item of HomeProductlist; track item) {
                          <div>
                            @if (item.CategoryId == category.CategoryId) {
                              <span
                              [routerLink]="['/product', item.ItemID]">{{item.ProductName}}</span>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </mat-menu>
        </div>
        <div class="mt p-l-20 p-r-20 fx-row fx-main-end fx-cross-end fx-flex-100">
          <div>
            <app-shopping-widgets [shoppingCartItems]="shoppingCartItems"></app-shopping-widgets>
          </div>
          @if (!isLoggedIn()) {
            <div class="enroll_img fx-row fx-main-center fx-cross-center">
              <div>
                <a class="avtar" mat-button [matMenuTriggerFor]="langMenu" #langMenuTrigger="matMenuTrigger">
                  <img width="18" [default]="'assets/images/user.png'">
                  &nbsp;<span
                  class="text-uppercase f-500 heading m-l-12 c-white f-w-100 xs-ew-font-size-15px" mat-button data-bind="label">SIGN
                  IN
                  <mat-icon iconPositionEnd class="display-inline-relative">arrow_drop_down</mat-icon>
                </span>
              </a>
            </div>
            <mat-menu #langMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="app-dropdown swal">
              <div class="logout-menu">
                <!-- Name -->
                <div class="enroll_img fx-row fx-main-around fx-cross-center">
                  <div>
                    <span class="text-uppercase f-500 xs-ew-font-size-12px"
                    data-bind="label">Guest</span>
                  </div>
                  <div class="avtar nocursor">
                    <mat-icon>perm_identity</mat-icon>
                  </div>
                </div>
                <!-- Sign Out -->
                @if (isLoggedIn()) {
                  <div class="fx-row fx-main-around fx-cross-center">
                    <button class="shop-btn product-button w-60  " mat-raised-button color="black" (click)="logout()">Sign
                    Out</button>
                  </div>
                }
                <!-- Sign In -->
                @if (!isLoggedIn()) {
                  <div class="fx-row fx-main-around fx-cross-center">
                    <button class="shop-btn product-button w-60  " mat-raised-button color="black" (click)="login()">Sign
                    In</button>
                  </div>
                }
                <!-- Orders -->
              </div>
            </mat-menu>
          </div>
        }
        @if (isLoggedIn()) {
          <div class="enroll_img fx-row fx-main-center fx-cross-center">
            <div>
              <a class="avtar" mat-button [matMenuTriggerFor]="langMenu" #langMenuTrigger="matMenuTrigger">
                <img [src]="$safeNavigationMigration(userServiceModal?.enrollerInfo?.ImageUrl)" width="18" [default]="'assets/images/user.png'">
                &nbsp;<span
                class="text-uppercase f-500 heading m-l-12 f-w-100 c-white xs-ew-font-size-15px" mat-button
                data-bind="label">{{userServiceModal?.enrollerInfo?.FirstName}}
                &nbsp;{{userServiceModal?.enrollerInfo?.LastName}}
                <mat-icon iconPositionEnd class="display-inline-relative">arrow_drop_down</mat-icon>
              </span>
            </a>
          </div>
          <mat-menu #langMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="app-dropdown swal">
            <div class="logout-menu">
              <!-- Name -->
              <div class="enroll_img fx-row fx-main-around fx-cross-center">
                <div>
                  <span class="text-uppercase f-500 xs-ew-font-size-12px" data-bind="label"
                  [textContent]="(userServiceModal?.customerData?.FirstName || userServiceModal?.enrollerInfo?.FirstName) + ' ' + (userServiceModal?.customerData?.LastName || userServiceModal?.enrollerInfo?.LastName)"></span>
                </div>
                <div class="avtar nocursor">
                  <img style="height:45px;width:45px;"
                    [src]="userServiceModal?.customerData?.ImageUrl || userServiceModal?.enrollerInfo?.ImageUrl"
                    alt="companylogo" [default]="'assets/images/user.png'">
                  </div>
                </div>
                <!-- Sign Out -->
                @if (isLoggedIn()) {
                  <div class="fx-row fx-main-around fx-cross-center">
                    <button class="shop-btn product-button w-60  " mat-raised-button color="black" (click)="logout()">Sign
                    Out</button>
                  </div>
                }
                <!-- Sign In -->
                @if (!isLoggedIn()) {
                  <div class="fx-row fx-main-around fx-cross-center">
                    <button class="shop-btn product-button w-60" (click)="login()" mat-raised-button color="black">Sign
                    In</button>
                  </div>
                }
                <!-- Orders -->
                <a>
                  <div class="  receiptOrder fx-row fx-main-start fx-cross-stretch fx-cap-h" routerLink="/orderhistory">
                    <mat-icon class="receipt">receipt</mat-icon>
                    @if (isLoggedIn()) {
                      <span class="m-l-7 f-w-100"
                        [ngClass]="{'text-gray': '/orderhistory' ? router.isActive('/orderhistory', true): false}">Order
                      History</span>
                    }
                  </div>
                </a>
                <!--MAnage Autoship-->
                <a>
                  <div class=" fx-row fx-main-start fx-cross-stretch fx-cap-h" routerLink="/manageautoship">
                    <mat-icon class="receipt">assessment</mat-icon>
                    @if (isLoggedIn()) {
                      <span class="m-l-17 f-w-100"
                        [ngClass]="{'text-gray': '/   manageautoship' ? router.isActive('/manageautoship', true): false}">Manage
                      Autoship</span>
                    }
                  </div>
                </a>
              </div>
            </mat-menu>
          </div>
        }
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
  <mat-toolbar class="fx-flex-100 print-fx-hide gt-sm-fx-hide" color="primary"
    [ngClass]="{'noColor header p-0-10': isTop , 'kuro header' : !isTop }">
  <mat-toolbar-row class="container p-0 h-90 fx-row">
    <div class="fx-row fx-flex-100">
      <div class="mt fx-row fx-main-start fx-cross-start fx-flex-33">
        <div class="logo1">
          <span class="gt-sm-fx-hide">
            <button mat-icon-button class="mat" (click)="toggleMobileMenu($event)">
              <mat-icon>menu</mat-icon>
            </button>
          </span>
        </div>
      </div>
      <div class="fx-row fx-main-center fx-cross-center fx-flex-33">
        <p class="margin-img">
          <a class="c-white logo" routerLink="/home"><img src="../../../../assets/images/logo_small.png"
            class="width-img" />
        </a>
      </p>
    </div>
    <div class="mt p-l-20 p-r-20 fx-row fx-main-end fx-cross-end fx-flex-33">
      <div>
        <app-shopping-widgets [shoppingCartItems]="shoppingCartItems"></app-shopping-widgets>
      </div>
    </div>
  </div>
</mat-toolbar-row>
</mat-toolbar>
}
@if (currentRouterPath != '/home') {
  <mat-toolbar color="primary" class="kuro header fx-row fx-main-center fx-cross-center fx-flex-100 lt-md-fx-hide">
    <mat-toolbar-row class="container p-0 h-90 p-r-10 fx-row">
      <div class="mt p-l-20 p-r-20 fx-row">
        <div>
          <p class="margin-img">
            <a class="c-white logo" routerLink="/home"><img src="../../../../assets/images/logo_small.png"
              class="width-img" />
          </a>
        </p>
      </div>
      <div class="m-l-30 fx-row fx-main-center fx-cross-center">
        <p class="heading">
          <span class="m-l-10 f-w-100" [ngClass]="{'text-gray': '/home' ? router.isActive('/home', true): false}"
          routerLink="/home">Home</span>
          <!-- <span class="m-l-15 f-w-100"
          [ngClass]="{'text-gray': '/products/all' ? router.isActive('/products/all', true): false}"
          (click)="run()" [matMenuTriggerFor]="menu">Shop <mat-icon class="display-inline-relative">
        arrow_drop_down</mat-icon></span> -->
        <span class="m-l-15 f-w-100"
          [ngClass]="{'text-gray': '/products/all' ? router.isActive('/products/all', true): false}"
        routerLink="/products/all">Shop</span>
        <span class="m-l-15 f-w-100" [ngClass]="{'text-gray': '/faq' ? router.isActive('/faq', true): false}"
        routerLink="/faq">FAQ</span>
        @if (!isLoggedIn()) {
          <span class="m-l-15 f-w-100"
            [ngClass]="{'text-gray': '/join' ? router.isActive('/join', true): false}"
          routerLink="/join">Join</span>
        }
        <span class="m-l-15 f-w-100"
          [ngClass]="{'text-gray': '/contact' ? router.isActive('/contact', true): false}"
        routerLink="/contact">Contact</span>
        <span class="m-l-15 f-w-100" [ngClass]="{'text-gray': '/about' ? router.isActive('/about', true): false}"
        routerLink="/about">About</span>
      </p>
    </div>
  </div>
  <mat-menu class="fx-row-in-menu" #menu="matMenu">
    <div id="header-menu" class="p-20 line_space fx-row fx-flex-100 fx-gap-right-20px">
      <div class="fx-row fx-flex-100">
        <div class="fx-row-wrap fx-main-start fx-cross-stretch fx-flex-100">
          @for (category of allItems; track category; let i = $index) {
            <div class="fx-col fx-main-start fx-cross-start fx-fill-size fx-flex-25-in-wrap lt-md-fx-flex-48-in-wrap"
              >
              <div
                class="p-relative fx-col fx-main-start fx-cross-start fx-fill-size fx-flex-24-in-col lt-md-fx-flex-100-in-col">
                <b><span [routerLink]="['/products', category.CategoryId]">{{category.Category}}</span></b>
                <span [routerLink]="['/products',category.CategoryId]">All</span>
                @for (item of HomeProductlist; track item) {
                  <div>
                    @if (item.CategoryId == category.CategoryId) {
                      <span
                      [routerLink]="['/product', item.ItemID]">{{item.ProductName}}</span>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </mat-menu>
  <div class="mt p-l-20 p-r-20 fx-row fx-main-end fx-cross-end fx-flex-100">
    <div>
      <app-shopping-widgets [shoppingCartItems]="shoppingCartItems"></app-shopping-widgets>
    </div>
    <div>
      <!-- <span  class="m-l-15 f-w-100"> -->
      @if (!isLoggedIn()) {
        <div class="enroll_img fx-row fx-main-center fx-cross-center">
          <div>
            <a class="avtar" mat-button [matMenuTriggerFor]="langMenu" #langMenuTrigger="matMenuTrigger">
              <img width="18" [default]="'assets/images/user.png'">
              &nbsp;<span
              class="text-uppercase f-500 heading m-l-12 f-w-100 c-white xs-ew-font-size-15px" mat-button data-bind="label">SIGN
              IN
              <mat-icon iconPositionEnd class="display-inline-relative">arrow_drop_down</mat-icon>
            </span>
          </a>
        </div>
        <mat-menu #langMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="app-dropdown swal">
          <div class="logout-menu">
            <!-- Name -->
            <div class="enroll_img fx-row fx-main-around fx-cross-center">
              <div>
                <span class="text-uppercase f-500 xs-ew-font-size-12px"
                data-bind="label">Guest</span>
              </div>
              <div class="avtar nocursor">
                <mat-icon>perm_identity</mat-icon>
              </div>
            </div>
            <!-- Sign Out -->
            @if (isLoggedIn()) {
              <div class="fx-row fx-main-around fx-cross-center">
                <button class="shop-btn product-button w-60  " mat-raised-button color="black"
                (click)="logout()">Sign Out</button>
              </div>
            }
            <!-- Sign In -->
            @if (!isLoggedIn()) {
              <div class="fx-row fx-main-around fx-cross-center">
                <button class="shop-btn product-button w-60" mat-raised-button color="black" (click)="login()">Sign
                In</button>
              </div>
            }
            <!-- Orders -->
          </div>
        </mat-menu>
      </div>
    }
  <!-- </span> -->
</div>
<div class="enroll_img fx-row fx-main-center fx-cross-center">
  @if (isLoggedIn()) {
    <div>
      <a class="avtar" mat-button [matMenuTriggerFor]="langMenu" #langMenuTrigger="matMenuTrigger">
        <img [src]="$safeNavigationMigration(userServiceModal?.enrollerInfo?.ImageUrl)" width="18" [default]="'assets/images/user.png'">
        &nbsp;<span
        class="text-uppercase f-500 heading m-l-12 f-w-100 c-white xs-ew-font-size-15px" mat-button
        data-bind="label">{{userServiceModal?.enrollerInfo?.FirstName}}
        &nbsp;{{userServiceModal?.enrollerInfo?.LastName}}
        <mat-icon iconPositionEnd class="display-inline-relative">arrow_drop_down</mat-icon>
      </span>
    </a>
  </div>
}
<mat-menu #langMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="app-dropdown swal">
  <div class="logout-menu">
    <!-- Name -->
    <div class="enroll_img fx-row fx-main-around fx-cross-center">
      <div>
        <span class="text-uppercase f-500 xs-ew-font-size-12px" data-bind="label"
        [textContent]="(userServiceModal?.customerData?.FirstName || userServiceModal?.enrollerInfo?.FirstName) + ' ' + (userServiceModal?.customerData?.LastName || userServiceModal?.enrollerInfo?.LastName)"></span>
      </div>
      <div class="avtar nocursor">
        <img style="height:45px;width:45px;"
          [src]="userServiceModal?.customerData?.ImageUrl || userServiceModal?.enrollerInfo?.ImageUrl"
          alt="companylogo" [default]="'assets/images/user.png'">
        </div>
      </div>
      <!-- Sign Out -->
      @if (isLoggedIn()) {
        <div class="fx-row fx-main-around fx-cross-center">
          <button class="shop-btn product-button w-60  " mat-raised-button color="black" (click)="logout()">Sign
          Out</button>
        </div>
      }
      <!-- Sign In -->
      @if (!isLoggedIn()) {
        <div class="fx-row fx-main-around fx-cross-center">
          <button class="shop-btn product-button w-60  " mat-raised-button color="black" (click)="login()">Sign
          In</button>
        </div>
      }
      <!-- Orders -->
      <a>
        <div class="avtar receiptOrder fx-row fx-main-start fx-cross-stretch fx-cap-h" routerLink="/orderhistory">
          <mat-icon class="receipt">receipt</mat-icon>
          @if (isLoggedIn()) {
            <span class="m-l-7 f-w-100"
              [ngClass]="{'text-gray': '/orderhistory' ? router.isActive('/orderhistory', true): false}">Order
            History</span>
          }
        </div>
      </a>
      <!--Manage Autoship-->
      <a>
        <div class="avtar fx-row fx-main-start fx-cross-stretch fx-cap-h" routerLink="/manageautoship">
          <mat-icon class="receipt">assessment</mat-icon>
          @if (isLoggedIn()) {
            <span class="m-l-7 f-w-100"
              [ngClass]="{'text-gray': '/   manageautoship' ? router.isActive('/manageautoship', true): false}">Manage
            Autoship</span>
          }
        </div>
      </a>
    </div>
  </mat-menu>
</div>
</div>
</mat-toolbar-row>
</mat-toolbar>
<mat-toolbar color="primary" class="kuro header fx-flex-100 print-fx-hide gt-sm-fx-hide">
  <mat-toolbar-row class="container p-0 h-90 fx-row">
    <div class="fx-row fx-flex-100">
      <div class="mt fx-row fx-main-start fx-cross-start fx-flex-33">
        <div class="logo1">
          <span class="gt-sm-fx-hide">
            <button mat-icon-button class="mat" (click)="toggleMobileMenu($event)">
              <mat-icon>menu</mat-icon>
            </button>
          </span>
        </div>
      </div>
      <div class="m-t-0 fx-row fx-main-center fx-cross-center fx-flex-33">
        <p class="margin-img">
          <a class="c-white logo" routerLink="/home"><img src="../../../../assets/images/logo_small.png"
            class="width-img" />
        </a>
      </p>
    </div>
    <div class="mt p-l-20 p-r-20 fx-row fx-main-end fx-cross-end fx-flex-33">
      <div>
        <app-shopping-widgets [shoppingCartItems]="shoppingCartItems"></app-shopping-widgets>
      </div>
    </div>
  </div>
</mat-toolbar-row>
</mat-toolbar>
}
</div>
}